export class CustomEmailSetting {
    subject: string;
    message: string;
}
